import { render, staticRenderFns } from "./instagram-swiper.vue?vue&type=template&id=2ebd59d4&scoped=true&"
import script from "./instagram-swiper.vue?vue&type=script&lang=js&"
export * from "./instagram-swiper.vue?vue&type=script&lang=js&"
import style0 from "./instagram-swiper.vue?vue&type=style&index=0&id=2ebd59d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebd59d4",
  null
  
)

export default component.exports